import { Component } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { GenericService } from "../../services/base/generic-service";
import { GenericCFLViewProperties } from './generic-cfl-view-properties';
import { GenericCflViewComponent } from './generic-cfl-view.component';
import { MatTableDataSource } from '@angular/material/table';

@Component({
  template: ''
})
export class GenericCFLViewFunctions<T> extends GenericCFLViewProperties<T> {

  constructor(genericService: GenericService<T>, router: Router,
    public matDialogforCfl: MatDialog, public matDialogRefForCfl: MatDialogRef<GenericCflViewComponent<T>>) {
    super(genericService, router);
  }
  openCFL<T>(TCtor: new (...args: any[]) => T, data: any): MatDialogRef<T, any> {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.height = this.getCflHeight == "" ? "550px" : this.getCflHeight;
    dialogConfig.width = this.getCflWidth == "" ? "800px" : this.getCflWidth;
    let arr: Array<string> = this.getCflDisplayedColumnsNamesList;
    if (arr.includes('Select')) {
      arr = this.getCflDisplayedColumnsNamesList;
    } else {
      arr.splice(0, 0, "Select");
    }
    var dict = {
      "identifier": this.getCflIdentifier,
      "selectedData": this.getCflSelectedData,
      "title": this.getCflTitle,
      "dataSourceUrl": this.getCflViewDataSourceURL,
      "isItSingleSelection": this.getIsCflSingleSelection == false ? false : true,
      "displayedColumn": arr,
      "sortColumn": this.getSortColumn,
      "filter": this.getCflFilterArray,
      "isItEnumList": this.getIsItCflEnumList,
      "EnumObjectNameToDisplay": this.getCflEnumObjectNameToDisplay,
      "EnumStoreName": this.getCflEnumStoreName,
      "EnumDataToStoreInDB": this.getCflEnumDataToStoreInDB,
      "cflNumberType": this.getCFLNumberType,
      "cflStringType": this.getCFLStringType,
      "cflRequestDataWithCode": this.getCFLRequestDataWithCode,
      "cflRequestDataInnerArrayName": this.getCFLRequestDataInnerObjName,
      "cflIsCancel": this.getCFLIsCancel == false ? false : true

    }
    dialogConfig.data = dict;
    dialogConfig.disableClose = true;
    const dialogRef = this.matDialogforCfl.open(TCtor, dialogConfig);
    return dialogRef;
  }
  onCloseCFL() {
    this.matDialogRefForCfl.close({ event: this.getCflSelectedData });

  }
  onChooseFromCFL() {
    this.matDialogRefForCfl.close({ event: this.getCflSelectedData});

  }

  onClearCFL() {
    this.matDialogRefForCfl.close({ event: 'CLEAR', isClear: true });
  }
}
